import { ReactElement } from "react";
import { Avatar, HStack, Text, VStack } from "@chakra-ui/react";
import { SelectionLoginUser } from "../../types";
import { isGoogleSSOAtom, themeColorAtom } from "../../store";
import { useAtom } from "jotai";
import { useColorToken } from "../../hooks/useColorToken";

type Props = {
  user: SelectionLoginUser;
  disabled?: boolean;
  onClick?: () => void;
};

export function SelectionLoginUserButton(props: Readonly<Props>): ReactElement {
  const boxShadowColor = useColorToken("login.login_button_bg");
  const [themeColor] = useAtom(themeColorAtom);
  const [, setIsGoogleSSO] = useAtom(isGoogleSSOAtom);

  const isDarkTheme = themeColor.endsWith("_dark");

  const handleClick = (): void => {
    setIsGoogleSSO(false);
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <HStack
      as="button"
      type="button"
      data-testid="selection-login-user"
      width="full"
      px={{ base: 3 }}
      py={3}
      boxShadow={isDarkTheme ? "none" : `0 3px 10px ${boxShadowColor}`}
      spacing={{ base: 3 }}
      background="white"
      color="common_text.dark"
      _active={{ bgColor: "white" }}
      _focus={{ bgColor: "white" }}
      _disabled={{ bgColor: "login.login_button_bg", cursor: "not-allowed" }}
      sx={{
        "@media (hover: hover)": {
          "&:hover:not([disabled])": { bgColor: "login.login_button_bg" },
        },
      }}
      onClick={handleClick}
      disabled={props.disabled}
    >
      <Avatar backgroundColor={props.user.color} size="sm" />
      <VStack align="flex-start" flex={1} overflow="hidden">
        <Text
          fontSize="xl"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          textAlign="left"
          width="full"
        >
          {props.user.nickname}
        </Text>
      </VStack>
    </HStack>
  );
}
